import { useTranslation } from "next-i18next";
import { Span } from "src/components/base";
import { Button } from "src/components/base/button";
import { IconChat } from "src/components/icons";

interface IFeedCardCommentButtonProps {
    url: string;
    count?: number;
    isCompact?: boolean;
    onClick?: () => void;
}

export const FeedCardCommentButton = ({ url, count, isCompact, onClick }: IFeedCardCommentButtonProps) => {
    const { t } = useTranslation("feed");
    return (
        <Button
            p={isCompact ? [0.5, 1] : 2}
            as="a"
            target="_blank"
            href={url}
            variant="ghost"
            size="sm"
            iconSpacing={isCompact ? (count && count > 0 ? [0.5, 1] : 0) : 1}
            leftIcon={<IconChat boxSize={3} />}
            onClick={onClick}
        >
            <Span>
                <Span display={isCompact ? "none" : ["none", "initial", "none", "initial"]}>{t("comment-button-label")}</Span>
                {count && count > 0 ? (
                    <Span
                        _before={{ content: isCompact ? "unset" : ["unset", `" ("`, "unset", `" ("`] }}
                        _after={{ content: isCompact ? "unset" : ["unset", `")"`, "unset", `")"`] }}
                    >
                        {count}
                    </Span>
                ) : undefined}
            </Span>
        </Button>
    );
};
